import { createSelector } from 'reselect';
import getFutureOrderingLimitGeneric from './getFutureOrderingLimitGeneric';

import getOrdering from './getOrdering';

export default createSelector(
  [getOrdering, getFutureOrderingLimitGeneric],
  (ordering, futureOrderingLimitGenericFallback): number => {
    const { futureOrderingEnableCatering } = ordering.config;

    if (!futureOrderingEnableCatering) {
      return 1;
    }

    /**
     * If futureOrderingEnableCatering is disabled it should return 1 else
     * the user wont be able to order catering, this should never return 0
     * to avoid that scenario.
     *
     * This logic was previously in all of the future ordering selectors
     * on web and mobile, and its now here for consistency.
     */
    return (
      ordering.config.futureOrderingLimitCatering ||
      futureOrderingLimitGenericFallback ||
      1
    );
  },
);
